<script>
  import uuid from "uuid-v4"
  import Accordion from "../Accordion.svelte"
  import EvolucionDeudasGrafico from "./Evolucion_deudas_grafico.svelte"

  export let documento

  const graficoId = uuid()
  let tipo = "HIPOTECARIO"
  $: selectId = `tipo-evolucion-deuda-${documento}-${graficoId}`
</script>

<div>
  <Accordion title="Gráfico" idx={graficoId} show={true}>
      <EvolucionDeudasGrafico {documento} {tipo}>
        <div slot="tipo" class="tipo-deuda">
          <label for={selectId} class="fg-secondary mb-1">Tipo de deuda</label>
          <select
            id={selectId}
            class="form-control form-control-sm"
            bind:value={tipo}
          >
            <option value="HIPOTECARIO">HIPOTECARIO</option>
            <option value="VEHICULAR">VEHICULAR</option>
            <option value="PRESTAMO">PRESTAMO</option>
            <option value="COMERCIAL">COMERCIAL</option>
          </select>
        </div>
      </EvolucionDeudasGrafico>
  </Accordion>
</div>

<style>
  .tipo-deuda {
    flex: 0 1 220px;
    width: 100%;
  }
</style>
